import { Box, styled } from '@mui/material';

export const DefaultNoOptionsMessageContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
